import React from "react";
import { GithubPicker } from "react-color";
import { X } from "lucide-react";

const colors = [
  "#B80000","#DB3E00","#FCCB00","#008B02","#006B76","#1273DE","#004DCF","#5300EB",
  "#EB9694","#FAD0C3","#FEF3BD","#C1E1C5","#BEDADC","#C4DEF6","#BED3F3","#D4C4FB",
  "#4D4D4D","#999999","#F44E3B","#FE9200","#FCDC00","#DBDF00","#A4DD00","#68CCCA",
  "#73D8FF","#AEA1FF","#FDA1FF","#333333","#808080","#cccccc","#D33115","#E27300",
  "#FCC400","#B0BC00","#68BC00","#16A5A5","#009CE0","#7B64FF","#FA28FF","#666666",
  "#B3B3B3","#9F0500","#C45100","#FB9E00","#808900","#194D33","#0C797D","#0062B1",
  "#653294","#AB149E",
];

const ColorPicker = ({ onChange, currentColor, handleClose, open }) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/30" onClick={handleClose} />
      <div className="relative bg-white dark:bg-slate-900 rounded-xl shadow-xl border border-slate-200 dark:border-slate-700 p-4">
        <div className="flex items-center justify-between mb-3">
          <p className="text-sm font-semibold text-slate-700 dark:text-slate-300">Elige un color</p>
          <button onClick={handleClose} className="p-1 rounded text-slate-400 hover:text-slate-600 transition-colors">
            <X className="w-4 h-4" />
          </button>
        </div>
        <GithubPicker
          width="240px"
          triangle="hide"
          color={currentColor}
          colors={colors}
          onChange={(color) => { onChange(color.hex); handleClose(); }}
        />
      </div>
    </div>
  );
};

export default ColorPicker;
